import { Component, Type } from '@angular/core';
import { Guard } from '../../services/guard.service';

import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs/Observable';
import { ModalSize, SmartModalService } from 'app/core/services/smart-modal.service';
import { RxComponent } from 'app/core/components/common/rx.component';
import { SessionService } from 'app/core/services/session.service';
import { DynamicOnboardingComponent } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.component';
import { RequestService } from 'app/core/services/request.service';
import { CompleteProfileComponent } from 'app/core/components/complete-profile/complete-profile.component';

@Component({
    selector: 'itpx-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends RxComponent {

    private buyerAdmin: boolean;
    private marketplaceUrl: string;
    private integrationUrl: string
    private tiles: Array<any> = [];
    private brandName = 'Leapest by Edcast';

    constructor(
        private guard: Guard,
        private configService: ConfigService,
        private modalService: SmartModalService,
        private sessionService: SessionService,
        private requestService: RequestService
    ) {
        super();
    }

    private openOnboardingModal(text: string, title: string, danger: boolean, data?: any, errorIfClosed: boolean = false): Observable<any> {
        let result = this.modalService.open(<Type<Component>>DynamicOnboardingComponent,
            { text: text, btn: (danger ? 'btn-danger' : 'btn-warning') }, title, ModalSize.Xl, 'center', false)
            .map(_ => data);

        return errorIfClosed ? result : result.neverError();
    }

    ngOnInit() {
        let user = this.sessionService.getUserDetails();
        let domainConfigData = this.configService.getDomainConfigData();
        this.brandName = (domainConfigData) ? domainConfigData.brandName : this.brandName;
        this.marketplaceUrl = this.configService.get('buyers').productMarketplace;
        this.integrationUrl = this.configService.get('server').integrationFramework;
        this.initializeTiles();

        if (user['groups'].indexOf('administrator') > -1 || user['groups'].indexOf('view-administrator') > -1) {
            this.tiles.push({
                title: 'LXP Configuration',
                redirectPath: '/lxp-config',
                description: 'Manage your LXP integration',
                icon: 'fa-cogs',
                color: 'orange',
                permission: 'lxp-configuration',
            })
        }

    }
    ngAfterViewInit() {

    }

    private initializeTiles() {
        this.tiles.push(
            {
                separator: 'Platform',
                permission: 'platformSeparator'
            },
            {
                title: 'Photon',
                redirectPath: '/',
                description: 'APIs, Clients, Policies, Groups, Systems',
                icon: 'fa-cogs',
                permission: 'amber',
                url: this.integrationUrl
            },
            {
                separator: 'Leapest',
                permission: 'leapestSeparator'
            },
            {
                title: 'Transactions',
                redirectPath: '/transactions',
                description: 'Manage Transactions and Seller Settlements',
                icon: 'fa-exchange-alt',
                permission: 'transactions',
            },
            {
                title: 'Agora',
                redirectPath: '/agora',
                description: 'Manage Master Data',
                icon: 'fa-database',
                permission: 'agora'
            },
            {
                title: 'Library',
                redirectPath: '/eden-platform',
                description: 'Manage Library Content',
                icon: 'fa-book',
                permission: 'library-platform'
            },
            {
                title: 'Voucher Management',
                redirectPath: '/voucher',
                description: 'Manage Platform Vouchers',
                icon: 'fa-receipt',
                permission: 'voucher'
            },
            {
                title: 'Account Management',
                redirectPath: '/dm',
                description: 'Manage Customer Domains',
                icon: 'fa-globe',
                permission: 'dm'
            },
            {
                title: 'Template Management',
                redirectPath: '/tm',
                description: 'Manage Notification Templates',
                icon: 'fa-file',
                permission: 'tm'
            },
            {
                title: 'Support Management',
                redirectPath: '/sm',
                description: 'Manage Support',
                icon: 'fa-user-headset',
                permission: 'sm'
            },
            {
                title: 'Registrations',
                redirectPath: '/contracts/platform/registrations',
                description: 'Manage Customer Registrations',
                icon: 'fa-user-plus',
                permission: 'registrations'
            }, {
            title: 'Platform Contract Templates',
            redirectPath: '/contracts/seller/platform',
            description: 'Compose & Manage Contract Templates',
            icon: 'fa-file-plus',
            permission: 'platformContractTemplates'
        }, {
            title: 'Platform Contracts',
            redirectPath: '/contracts/platform/contracts',
            description: 'Compose & Manage Contracts',
            icon: 'fa-file-exclamation',
            permission: 'platformContracts'
        }, {
            title: 'Notification Management',
            redirectPath: '/notification-management',
            description: 'Send Broadcast Notifications',
            icon: 'fa-bell',
            permission: 'notificationManagement'
        },
            {
                title: 'Scorm-Cloud Registrations',
                redirectPath: '/scorm-cloud/registrations',
                description: 'Manage Scorm-Cloud Registrations',
                icon: 'fa-upload',
                hideInProd: true,
                permission: 'voucher'
            },
            {
                title: 'Integration',
                redirectPath: '/',
                description: 'Transfer all your files in one go.',
                icon: 'fa-hand-holding-box',
                permission: 'sellerProducts.bulk-uploads',
                url: this.integrationUrl
            },
            {
                title: 'Approvals',
                redirectPath: '/platform-approvals',
                description: 'Product Approvals, Course Approvals, Custom Course Approval',
                icon: 'fa-gift-card',
                color: 'deep-carmine',
                permission: 'approvalPlatform'
            },
            {
                separator: 'Buyer',
                permission: 'buyerSeparator'
            },
            {
                title: 'Marketplace',
                redirectPath: '/',
                description: 'Shop for Materials & Exams',
                icon: 'fa-store',
                color: 'purple',
                permission: 'purchase',
                url: this.marketplaceUrl
            },
            {
                title: 'Vouchers',
                redirectPath: '/solar',
                description: 'View, Assign & Return Vouchers',
                icon: 'fa-ticket-alt',
                color: 'purple',
                permission: 'solar'
            },
            {
                title: 'Orders & Invoices',
                redirectPath: '/order-management',
                description: 'View Orders and Download Invoices',
                icon: 'fa-dolly-flatbed',
                color: 'purple',
                permission: 'transactionsBuyer',
            },
            {
                title: 'Courses',
                redirectPath: '/course-management',
                description: 'Manage & Create Class and Exam Sessions',
                icon: 'fa-graduation-cap',
                color: 'purple',
                permission: 'courses',
            },
            {
                title: 'Course Events',
                redirectPath: '/course-management/course-events',
                description: 'Manage Events procured on the Marketplace',
                icon: 'fa-graduation-cap',
                color: 'purple',
                permission: 'lms-light-buyer'
            },
            {
                separator: 'Seller',
                permission: 'sellerSeparator'
            },
            {
                title: 'Marketplace',
                redirectPath: '/',
                description: 'Browse the Marketplace Storefront',
                icon: 'fa-store',
                color: 'green',
                permission: 'sellerMarketplace',
                url: this.marketplaceUrl
            },
            {
                title: 'Products & Services',
                redirectPath: '/product-seller/overview',
                description: 'Manage your Products & Services',
                icon: 'fa-box',
                color: 'green',
                permission: 'sellerProducts'
            },
            {
                title: 'Pricing Management',
                redirectPath: '/pricing-seller',
                description: 'Manage Price Lists & Subscription Plans',
                icon: 'fal fa-file-invoice-dollar',
                color: 'green',
                permission: 'sellerPricing'
            },
            {
                title: 'Contracts & Segments',
                redirectPath: '/contracts-segments',
                description: 'Manage Contracts, Templates and Buyer Segments',
                icon: 'fa-handshake',
                color: 'green',
                permission: 'sellerContractsSegments'
            },
            {
                title: 'Order Management',
                redirectPath: '/seller-order-management',
                description: 'Manage Orders & Fulfillment',
                icon: 'fa-store',
                color: 'green',
                permission: 'solar.exams.seller-exam-fulfillment'
            },
            {
                title: 'Promotions',
                redirectPath: '/promotions',
                description: 'Manage Promotions',
                icon: 'fa-gift-card',
                color: 'green',
                permission: 'promotions'
            },
            {
                separator: 'General',
                permission: 'generalSeparator'
            },
            {
                title: 'Organization Profile',
                redirectPath: '/organization',
                description: 'Manage Your Account Details and Users',
                icon: 'fa-building',
                color: 'orange',
                permission: 'organization'
            },
            {
                title: 'Legal',
                redirectPath: '/legal',
                description: `See ${this.brandName} Terms & Conditions`,
                icon: 'fa-info-circle',
                color: 'orange',
                permission: 'legal'
            },
            {
                title: 'Knowledge Base',
                redirectPath: '/support',
                description: 'Browse Our User Guides and FAQ',
                icon: 'fa-question-circle',
                color: 'orange',
                permission: 'support'
            }
        )
    }

    private openModal() {
        this.modalService.open(<Type<Component>>CompleteProfileComponent,
            { text: 'Complete Profile', btn: 'btn-danger' }, 'Profile Completeion Shortcut', ModalSize.Xl, 'center', true)
            .bindToLifecycle(this)
            .catchAndEmit(e => console.log(e))
            .subscribe(e => console.log(e), e => console.log(e));
    }

    ngOnDestroy(): void {
        setTimeout(this.modalService.close(), 100);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/dashboard/dashboard.component.ts